const PATH = '/insiders';

export default {
    async getInsidersBySymbol(symbol, { query }) {

        return axios.get(`${PATH}/list/${symbol}`, {params: {query}});
    }
}
